export default "__VITE_ASSET__BbYc9xNo__"